import { fromJS } from "immutable";
import * as types from "../constants";

const defaultState = fromJS({
  data: [],
  search: 0,
  rateProduct: [],
});

let result = "";

const listProduct = (state = defaultState, action) => {
  switch (action.type) {
    case types.GET_LIST_PRODUCT_RESULT:
      result = action.payload;
      return state.set("data", result.data.products.edges).set("search", 0);

    case types.GET_LIST_PRODUCT_SEARCH_RESULT:
      result = action.payload;
      return state.set("data", result.data.products.edges).set("search", 1);

    case types.GET_RATE_PRODUCT_RESULT:
      result = action.payload;
      return state.set("rateProduct", result);

    default:
      return state;
  }
};

export default listProduct;
